import React from 'react';
import { SlideLayout } from './SlideLayout';
import { motion } from 'framer-motion';
import { Flame, Target, Users, Zap, Award, CheckCircle2 } from 'lucide-react';
export function Slide5_Forge() {
  const day1Curriculum = ['The 12 Truths of Direct Sales', 'Core Values of Top Performers', 'Role Clarity & Expectations', 'Personal Fuel – Vision & Goals', 'Structure & Accountability', 'The Cycle of Achievement'];
  const day2Curriculum = ['Mastering the Approach', 'Talking to Strangers', 'Meta-Verbal Mastery', 'The 10-Step Approach Cycle', 'Handling Objections', 'Rules & Standards', '30-Day Commitment Challenge'];
  const repFeatures = ['Script memorization tool', 'Every Sales School session, recorded', 'One curated video a day for 30 days', 'Daily success journal and planner'];
  const leadershipFeatures = ['Build and manage your org chart', 'Upload your own training videos', 'Track every rep\u2019s progress'];
  const characteristics = [{
    icon: Zap,
    title: 'Mindset + Skillset',
    desc: 'Rookies gain identity, purpose, and habits'
  }, {
    icon: Users,
    title: 'Universal & Transferable',
    desc: 'Works across all door-to-door industries'
  }, {
    icon: Target,
    title: 'Immersive & Realistic',
    desc: 'No sugarcoating—reps leave clear on the challenge'
  }, {
    icon: Award,
    title: 'Commitment-Driven',
    desc: 'Ends with a 30-day pledge for accountability'
  }];
  return <SlideLayout data-id="element-395" data-mp="3hv5crbqei56r">
      <div className="flex flex-col h-full justify-center space-y-6 sm:space-y-8" data-id="element-396" data-mp="3hvnjj2aow1sx">
        {/* Header */}
        <div className="text-center space-y-3" data-id="element-397" data-mp="3d45heawxjv6d">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-orange-500/15 border border-orange-500/30 mb-2" data-id="element-398" data-mp="3d2c8sq2rb0vq">
            <Flame className="w-7 h-7 text-orange-500" data-id="element-399" data-mp="3e4p85lwuqk4v" />
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-3xl md:text-4xl font-bold text-white" data-id="element-400" data-mp="3iwh1g47e73yp">
            Sales School
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} data-id="element-401" data-mp="2v638mbgzh132">
            <span className="inline-block px-4 py-2 rounded-full bg-orange-500/10 border border-orange-500/30 text-orange-400 font-semibold tracking-wide uppercase text-sm" data-id="element-402" data-mp="ffgz7k069niv">
              Two-Day Live Event
            </span>
          </motion.div>

        </div>

        {/* Curriculum Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-7xl mx-auto w-full items-stretch" data-id="element-403" data-mp="24ygjrm7foi5l">
          {/* Day 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2
        }} className="bg-slate-900/40 border border-slate-800 rounded-xl p-5 sm:p-6 flex flex-col" data-id="element-404" data-mp="1v6arebd9rypv">
            <div className="mb-4 pb-3 border-b border-slate-800" data-id="element-405" data-mp="1h9e1qd8w0nak">
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-406" data-mp="1c8glw7bco5c8">Day 1</h3>
              <p className="text-orange-400 font-medium" data-id="element-407" data-mp="179x1wcgbh3mi">
                Foundation, Mindset & Structure
              </p>
              <p className="text-slate-500 text-sm mt-1" data-id="element-408" data-mp="36lfzxw030rhe">7.5 Hours</p>
            </div>

            <ul className="space-y-2 mb-5 flex-1" data-id="element-409" data-mp="31o6bojofilv5">
              {day1Curriculum.map((item, idx) => <li key={idx} className="flex items-start text-sm text-slate-300" data-id="element-410" data-mp="39o3z3f3ez9z6" data-mpi={idx}>
                  <CheckCircle2 className="w-4 h-4 text-orange-500/50 mr-2.5 shrink-0 mt-0.5" data-id="element-411" data-mp="2zpeqye1bl3w4" />
                  <span data-id="element-412" data-mp="2zrr3gbob6m1s">{item}</span>
                </li>)}
            </ul>

            <div className="bg-slate-800/50 rounded-lg p-3.5 border border-slate-700/50" data-id="element-413" data-mp="34qki47fc0j3j">
              <p className="text-xs text-slate-400" data-id="element-414" data-mp="2qv01jin2scza">
                <span className="text-orange-400 font-bold uppercase text-xs tracking-wider block mb-1" data-id="element-415" data-mp="2vo1irxar8om1">
                  Outcome
                </span>
                Clear-eyed, motivated, and personally committed
              </p>
            </div>
          </motion.div>

          {/* Day 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3
        }} className="bg-slate-900/40 border border-slate-800 rounded-xl p-5 sm:p-6 flex flex-col" data-id="element-416" data-mp="27xyvrvlp68ua">
            <div className="mb-4 pb-3 border-b border-slate-800" data-id="element-417" data-mp="22c6pwo4cjffo">
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-418" data-mp="22dhuur9j2t8d">Day 2</h3>
              <p className="text-orange-400 font-medium" data-id="element-419" data-mp="1xcbymjgnsnu3">
                Skills, Communication & Confidence
              </p>
              <p className="text-slate-500 text-sm mt-1" data-id="element-420" data-mp="2c8jej7l1b33k">7.5 Hours</p>
            </div>

            <ul className="space-y-2 mb-5 flex-1" data-id="element-421" data-mp="27aroyk7v3t2j">
              {day2Curriculum.map((item, idx) => <li key={idx} className="flex items-start text-sm text-slate-300" data-id="element-422" data-mp="2l1wid4kmzp4f" data-mpi={idx}>
                  <CheckCircle2 className="w-4 h-4 text-orange-500/50 mr-2.5 shrink-0 mt-0.5" data-id="element-423" data-mp="2v0m2z53x3nod" />
                  <span data-id="element-424" data-mp="2q1skey9rx6hc">{item}</span>
                </li>)}
            </ul>

            <div className="bg-slate-800/50 rounded-lg p-3.5 border border-slate-700/50" data-id="element-425" data-mp="2pzy3rw5jc0j2">
              <p className="text-xs text-slate-400" data-id="element-426" data-mp="1nmjo102afe2e">
                <span className="text-orange-400 font-bold uppercase text-xs tracking-wider block mb-1" data-id="element-427" data-mp="1rqzsqy060fg1">
                  Outcome
                </span>
                Knowing what to say and believing they can do it
              </p>
            </div>
          </motion.div>

          {/* Month 1 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.4
        }} className="bg-slate-900/40 border border-orange-500/30 rounded-xl p-5 sm:p-6 flex flex-col" data-id="element-428" data-mp="26dt27mn06r0b">
            <div className="mb-4 pb-3 border-b border-slate-800" data-id="element-429" data-mp="l219lffovb7t">
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-430" data-mp="l3vw2y6lzbe0">Month 1</h3>
              <p className="text-orange-400 font-medium" data-id="element-431" data-mp="q0uptfmd1gbo">The Forge App</p>
              <p className="text-slate-500 text-sm mt-1" data-id="element-432" data-mp="ii4x6zrrpzz2">
                Included with every ticket
              </p>
            </div>

            <div className="flex-1 space-y-4" data-id="element-433" data-mp="doa5pa5x8gpf">
              <div data-id="element-434" data-mp="8qig4msr16oe">
                <h4 className="text-orange-400 font-bold uppercase text-xs tracking-wider mb-2" data-id="element-435" data-mp="8s1xyhu1zpsa">
                  For Reps
                </h4>
                <ul className="space-y-2" data-id="element-436" data-mp="11fxqdaclavj9">
                  {repFeatures.map((item, idx) => <li key={idx} className="flex items-start text-sm text-slate-300" data-id="element-437" data-mp="11dl8ex6u0l67" data-mpi={idx}>
                      <CheckCircle2 className="w-4 h-4 text-orange-500/50 mr-2.5 shrink-0 mt-0.5" data-id="element-438" data-mp="rggluw92qnov" />
                      <span data-id="element-439" data-mp="nfem8eb8w9md">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="pt-4 border-t border-slate-800" data-id="element-440" data-mp="3c5w8df19fq8p">
                <h4 className="text-orange-400 font-bold uppercase text-xs tracking-wider mb-2" data-id="element-441" data-mp="385cauacrykm1">
                  For Leadership
                </h4>
                <ul className="space-y-2" data-id="element-442" data-mp="1b8426s8y7txa">
                  {leadershipFeatures.map((item, idx) => <li key={idx} className="flex items-start text-sm text-slate-300" data-id="element-443" data-mp="1252y0x3n8cw9" data-mpi={idx}>
                      <CheckCircle2 className="w-4 h-4 text-orange-500/50 mr-2.5 shrink-0 mt-0.5" data-id="element-444" data-mp="174z2syk608cv" />
                      <span data-id="element-445" data-mp="1uv1u3cg99aaf">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Characteristics Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 max-w-6xl mx-auto w-full" data-id="element-446" data-mp="1l3oz4bz5u406">
          {characteristics.map((char, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4 + idx * 0.1
        }} className="bg-slate-900/30 border border-slate-800/50 rounded-lg p-3.5" data-id="element-447" data-mp="2ds31f3xa7mhj" data-mpi={idx}>
              <char.icon className="w-5 h-5 text-orange-500 mb-2" data-id="element-448" data-mp="31mwmvt06k67i" />
              <h4 className="text-white font-bold text-sm mb-1" data-id="element-449" data-mp="2wp4qalolbvwz">
                {char.title}
              </h4>
              <p className="text-slate-400 text-xs leading-relaxed" data-id="element-450" data-mp="28yilr4dsotrq">
                {char.desc}
              </p>
            </motion.div>)}
        </div>

        {/* Pricing */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="text-center" data-id="element-451" data-mp="2ixzpvhdeezll">
          <div className="inline-flex items-center justify-center gap-5 mx-auto rounded-full border border-slate-800 bg-slate-900/40 px-6 py-3" data-id="element-452" data-mp="3pditdfujdife">
            <span className="text-2xl font-bold text-white leading-none" data-id="element-453" data-mp="1wvm4qu3oifz2">
              $250
              <span className="ml-2 text-sm font-medium text-slate-400" data-id="element-454" data-mp="1rylx4er6l55u">
                per ticket
              </span>
            </span>
            <span className="w-px h-5 bg-slate-700" aria-hidden="true" data-id="element-455" data-mp="1n4rdfbbksq6r" />
            <span className="text-sm text-slate-400 leading-none" data-id="element-456" data-mp="1i6zl4g70r221">
              Discounts on packs of{' '}
              <span className="text-orange-400 font-medium" data-id="element-457" data-mp="1e7qs5djsz87j">10 or more</span>
            </span>
          </div>
        </motion.div>
      </div>
    </SlideLayout>;
}